var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('v-card',{attrs:{"rounded":"lg","min-height":"268"}},[_c('custom-loading',{attrs:{"type":"staticPage"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }